import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { cardCls, inputCls, labelCls } from "./accountingUtils";

/** AccountingSettings — per-user defaults (tax rate applied to new expenses). */
const AccountingSettings = ({ base, settings, onSaved }) => {
  const [rate, setRate] = useState(String(settings?.default_tax_rate ?? 13));
  const [saving, setSaving] = useState(false);

  useEffect(() => { setRate(String(settings?.default_tax_rate ?? 13)); }, [settings]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`${base}/settings`, { default_tax_rate: parseFloat(rate) || 0 });
      onSaved?.(data);
      toast.success("Default tax rate saved");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`${cardCls} max-w-md space-y-3`} data-testid="acct-settings">
      <div>
        <div className="text-sm font-semibold text-white">Default tax rate</div>
        <p className="mt-1 text-xs text-white/50">Used whenever "Tax is" is set to included or excluded on a new expense. Ontario HST is 13%.</p>
      </div>
      <div>
        <label className={labelCls}>Rate %</label>
        <input type="text" inputMode="decimal" value={rate} onChange={(e) => setRate(e.target.value.replace(/[^0-9.]/g, ""))} data-testid="acct-settings-rate" className={`mt-1 ${inputCls} font-mono`} />
      </div>
      <button type="button" onClick={save} disabled={saving} data-testid="acct-settings-save" className="rounded-md bg-[#1a3fd1] px-4 py-2 text-xs font-semibold text-white hover:bg-[#1a3fd1]/85 disabled:opacity-60">
        {saving ? "Saving…" : "Save"}
      </button>
    </div>
  );
};

export default AccountingSettings;
